import request from '@/apis/request'
const resource = 'anonymous'

export default {
  getLastWin: (params) => { 
    return request.get(`${resource}/last-win`, { params })
  },

  postClickCounter: (data) => {
    return request.post(`${resource}/click-counter`,data)
  },

  getBankTypeList: () => { 
    return request.get(`${resource}/bank-types`)
  },

  getBanners: (params) => { 
    return request.get(`${resource}/banners`,{params})
  },

  getUserComission: (params) => { 
    return request.get(`${resource}/user-commissions`,{params})
  },

  getPricing: (params) => { 
    return request.get(`${resource}/pricing`,{params})
  },
  
  getAgentDetail: (params) => { 
    return request.get(`${resource}/agent-details`,{params})
  },

  getNews: (params) => {
    return request.get(`${resource}/news`, { params })
  }, 

  getAgentInfo: (params) => { 
    return request.get(`${resource}/agent-info`,{ params })
  },
}